import type { VAxios } from '../../define/axios/Axios';

export interface GenerateTitlePromptParams {
  /** 爆款商品标题，不可为空或纯空白 */
  title: string;
  /** 目标语言，如「英语」。未传则根据标题自动判断 */
  language?: string;
  /** 标题最大字符长度。未传则使用输入标题当前长度 */
  max_length?: number;
  /** 额外附加要求，会拼接到系统 prompt 中 */
  prompt?: string;
}

export const createApi = (defHttp: VAxios) => ({
  /**
   * 标题反推提示词：输入爆款商品标题，由 LLM 生成可复用的标题生成提示词
   * 成功时返回 result 字符串；失败时由全局 responseCb 抛错并提示 message
   */
  generateTitlePrompt: (params: GenerateTitlePromptParams) => {
    return defHttp.post<string>({
      url: '/goods-title/title-prompt/generate',
      params,
    });
  },
});
